import ConfigurablePane from './_configurable-pane.js'
import ConfigurableText from './_configurable-text.js'
import FlexItemBase from './_flex-item-base.js'
import ConfigurableSizeBounds from './_configurable-size-bounds.js'
import Hideable from './_hideable.js'
import ConfigurablePadding from './_configurable-padding.js'
import ConfigurableBackground from './_configurable-background.js'
import Animation from './_animation.js'

export default {
  name: 'CustomTextInput',
  values: {
    stopImmediatePropagation: false,
    keepFocusOnOutsideClick: false,
    fractionalSize: 2,
    placeholderText: undefined,
    placeholderTextFocused: undefined,
    style: {
      placeholder: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      base: {
        alignItems: 'center',
        justifyContent: 'flex-end',
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: FlexItemBase,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      hover: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      error: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      focus: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      disabled: {
        $mixin: [
          {
            configSet: ConfigurablePane,
          },
          {
            configSet: ConfigurableText,
          },
          {
            configSet: ConfigurableSizeBounds,
          },
        ],
      },
      cursor: {
        width: '1px',
        height: '15px',
        padding: '0 0 0 1px',
        $mixin: [
          {
            configSet: Hideable,
          },
          {
            configSet: ConfigurablePadding,
          },
          {
            configSet: ConfigurableBackground,
          },
        ],
      },
      innerContainer: undefined,
    },
    cursorAnimation: {
      configSet: Animation,
      configValues: {
        animationDuration: '0.5s',
        animationIterationCount: 'infinite',
        animationDirection: 'alternate',
        keyframes: {
          from: {
            opacity: '0',
          },
          to: {
            opacity: '1',
          },
        },
      },
    },
  },
  meta: {
    extendable: false,
  },
}
